module.exports = __webpack_public_path__ + "img/stand.3ac69ddd.svg";